import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { MediaFileOrcadentDeletedAction, MediaFileOrcadentUploadedAction, selectAnamneseUploadedOrcadentFiles, UploadedFileInfoAnamnese } from "libs/anamnese/src/lib/store";
import { AnamneseOrcadentUploadType, FileEventType, MediaModel } from "libs/media/src/lib";
import { ACTION } from "libs/tm-common/src/lib/constants/subcomponent.actions";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";
import { OrcadentJawDataType } from "libs/ux-components/src/lib/container/data-transfer/upload-stl";
import { first, Subscription } from "rxjs";

@Component({
	selector: "tm2-anamnese-fileupload-orcadent",
	templateUrl: "./anamnese-fileupload-orcadent.component.html",
	styleUrl: "./anamnese-fileupload-orcadent.component.scss"
})
export class AnamneseFileuploadOrcadentComponent implements OnInit, OnDestroy{
	@Input() patientId : string;
	@Output() next = new EventEmitter<any>();

	OrcadentJawDataType = OrcadentJawDataType;

	disableNext: boolean = false;
	uploadedFilesSubscription: Subscription;

	uploadedBiteFiles: {uj: Partial<MediaModel>, lj: Partial<MediaModel> } = {uj: {}, lj: {}};
	uploadedRegistrationFiles: {uj: Partial<MediaModel>, lj: Partial<MediaModel> } = {uj: {}, lj: {}};
	uploadedImageFiles: UploadedFileInfoAnamnese[];

	constructor(private store: Store<AppState>){
	}

	ngOnInit(): void {
		this.store.pipe(select(selectAnamneseUploadedOrcadentFiles), first()).subscribe( (uploadedFiles) => {
			let ujBite = uploadedFiles.jaws.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.UJ_BITE);
			let ljBite = uploadedFiles.jaws.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.LJ_BITE);
			let registrationUj = uploadedFiles.jaws.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.UJ_REGISTRATION);
			let registrationLj = uploadedFiles.jaws.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.LJ_REGISTRATION);

			this.assignFileData(this.uploadedBiteFiles.uj, ujBite);
			this.assignFileData(this.uploadedBiteFiles.lj, ljBite);
			this.assignFileData(this.uploadedRegistrationFiles.uj, registrationUj);
			this.assignFileData(this.uploadedRegistrationFiles.lj, registrationLj);
		})

		this.uploadedFilesSubscription = this.store.pipe(select(selectAnamneseUploadedOrcadentFiles)).subscribe((uploadedFiles: any) => {
			this.uploadedImageFiles = [...uploadedFiles.extraorals, ...uploadedFiles.intraorals, ...uploadedFiles.miscellaneous];
			this.disableNext = !(this.checkForCompleteness(uploadedFiles));
		});
	}

	ngOnDestroy(): void {
		this.uploadedFilesSubscription.unsubscribe();
	}

	onFileEvent($event, isUpperJaw, orcadentStlType: OrcadentJawDataType) {
		const mediaId = $event.payload?.id
		const orgFilename = $event.payload?.orgFilename;
		let uploadedJawType;

		if ( orcadentStlType === OrcadentJawDataType.BITE ){
			uploadedJawType = isUpperJaw ? AnamneseOrcadentUploadType.UJ_BITE :  AnamneseOrcadentUploadType.LJ_BITE;
		}else{
			uploadedJawType = isUpperJaw ? AnamneseOrcadentUploadType.UJ_REGISTRATION :  AnamneseOrcadentUploadType.LJ_REGISTRATION;
		}

		switch ($event.type) {
			case FileEventType.UPLOADED:
				this.store.dispatch(new MediaFileOrcadentUploadedAction(uploadedJawType, mediaId, orgFilename) )
				break;
			case FileEventType.ERROR:
				console.error('File Upload Error', $event.payload);
				break;
			case FileEventType.DELETED:
				this.store.dispatch(new MediaFileOrcadentDeletedAction(uploadedJawType))
				break;
		}
	}

	onAction(action){
		switch (action.type) {
			case ACTION.BACK:
				this.next.emit({type: ACTION.BACK});
				break;
			case ACTION.NEXT:
				this.next.emit({type: ACTION.OPTIONS});
				break;
		}
	}

	private checkForCompleteness(uploadedFiles): boolean {
		let jaws: UploadedFileInfoAnamnese[] =  uploadedFiles.jaws
		return !!jaws?.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.UJ_BITE)
			&& !!jaws?.find(elem => elem.orcadentType === AnamneseOrcadentUploadType.LJ_BITE);
	}

	private assignFileData(target: Partial<MediaModel>, source: UploadedFileInfoAnamnese) {
		if (source) {
			target.orgFilename = source.orgFilename;
			target._id = source.mediaId;
		}
	}
}
